import * as helpAndLearningAPI from "app/api/helpAndLearningAPI";
import {
  IconLogo,
  IconLogoEvo,
  IconLogoGalaxyBet,
} from "app/components/Icon/Icon";
import { CmsHelper } from "app/helpers/cmsHelper";
import affpapa from "app/images/logos/affpapa.png";
import BankTransferLogo from "app/images/logos/bankTransferLogo.png";
import bitcoin from "app/images/logos/bitcoin-Logo.png";
import chromeicon from "app/images/logos/chromeicon.png";
import ethereum from "app/images/logos/ethereum.png";
import FooterLogos from "app/images/logos/footerLogos.png";
import icon18plus from "app/images/logos/icon18plus.png";
import mastercard from "app/images/logos/mastercard.png";
import NetellerLogo from "app/images/logos/netellerLogo.png";
import SkrillLogo from "app/images/logos/skrillLogo.png";
import usdt from "app/images/logos/usdt.png";
import visa from "app/images/logos/visa.png";
import ENV from "config";
import React, { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import LazyLoad from "react-lazyload";
import sanitizeHtml from "sanitize-html";
import PublicModal from "../../components/PublicModal/PublicModal";
import "./Footer.scss";
const LogoAlderney = React.lazy(
  () => import("app/components/Logos/LogoAlderney")
);

type Props = {
  intl: Record<string, any>;
};

const Footer: React.FC<Props> = ({ intl }) => {
  const [showModal, setShowModal] = useState(false);
  const [html, setHtml] = useState<any>(null);
  const [screenName, setScreenName] = useState("terms-and-conditions");
  const [languageId, setLanguageId] = useState(
    CmsHelper.getLanguageId(intl.locale)
  );

  const requestContent = () => {
    console.log(screenName, languageId);
    helpAndLearningAPI
      .requestCMSContent(screenName, languageId)
      .then(resp => {
        setHtml(resp.data.contentlets[0].body);
      })
      .catch(error => {
        console.log(error);
        setHtml("No Content returned");
      });
  };

  const toggleTAC = (ev: React.MouseEvent) => {
    setScreenName("terms-and-conditions");
    setShowModal(true);
  };

  const togglePrivacyPolicy = (ev: React.MouseEvent) => {
    ev.preventDefault();
    setScreenName("privacy-policy");
    setShowModal(true);
  };

  const toggleResponsibleGaming = (ev: React.MouseEvent) => {
    ev.preventDefault();
    setScreenName("responsible-gaming");
    setShowModal(true);
  };

  const onCloseModal = () => {
    console.log("closing modal");
    setShowModal(false);
  };

  useEffect(() => {
    requestContent();
  }, []);

  useEffect(() => {
    requestContent();
  }, [showModal]);

  return (
    <div className="footer-container">
      <div className="footer-container__footer">
        {ENV.CSS_THEME === "DEFAULT" && <IconLogo />}
        {ENV.CSS_THEME === "EVO" && <IconLogoEvo />}
        {ENV.CSS_THEME === "GALAXYBET" && <IconLogoGalaxyBet />}
        <div className="footer-container__footer__message">
          {ENV.CSS_THEME === "DEFAULT" && (
            <FormattedMessage tagName="span" id="home-footer-message" />
          )}
          {ENV.CSS_THEME === "GALAXYBET" && (
            <a href={ENV.SPEED_URL + "/ams-web/#login"}>Agent Login</a>
          )}
        </div>
        <div className="footer-container__footer__links">
          <div
            onClick={toggleTAC}
            className="footer-container__footer__link"
            data-qa={"footer-container__footer__link__terms__and__conditions"}
          >
            <FormattedMessage tagName="span" id="home-termsandconditions" />
          </div>
          <div
            onClick={togglePrivacyPolicy}
            className="footer-container__footer__link"
            data-qa={"footer-container__footer__link__privacy__policy"}
          >
            <FormattedMessage tagName="span" id="home-privacypolicy" />
          </div>
          <div
            onClick={toggleResponsibleGaming}
            className="footer-container__footer__link"
            data-qa={"footer-container__footer__link__responsible__gaming"}
          >
            <FormattedMessage tagName="span" id="home-responsiblegaming" />
          </div>
        </div>

        <div className="footer-container__footer__cashier-logos">
          <LazyLoad>
            <img src={SkrillLogo} alt="Skrill" />
          </LazyLoad>
          <LazyLoad>
            <img src={NetellerLogo} alt="Neteller" />
          </LazyLoad>
          <LazyLoad>
            <img
              className={"banktransfer"}
              src={BankTransferLogo}
              alt="BankTransfer"
            />
          </LazyLoad>
          <LazyLoad>
            <img src={visa} alt="Visa" className="visa" />
          </LazyLoad>
          <LazyLoad>
            <img src={mastercard} alt="Mastercard" />
          </LazyLoad>
        </div>

        <div className="footer-container__footer__cashier-crypto">
          {/* <LazyLoad>
            <img src={applepay} alt="Apple pay" className="applepay" />
          </LazyLoad>
          <LazyLoad>
            <img src={googlepay} alt="Google Pay" className="googlepay" />
          </LazyLoad> */}
          <LazyLoad>
            <img src={bitcoin} alt="Bitcoin" className="greyed-out" />
          </LazyLoad>
          <LazyLoad>
            <img src={ethereum} alt="Ethereum" className="greyed-out" />
          </LazyLoad>
          <LazyLoad>
            <img src={usdt} alt="USDT" className="greyed-out" />
          </LazyLoad>
          {/* <LazyLoad>
            <img src={interac} alt="Interac" className="interac" />
          </LazyLoad> */}
        </div>

        {ENV.CSS_THEME === "GALAXYBET" && (
          <div className="footer-galaxy-chrome-icons">
            <img src={chromeicon} alt="chrome" />
            <img src={icon18plus} alt="18+" />
          </div>
        )}
        <div className="footer-container__footer__other-logos">
          <div
            onClick={() => {
              window.open("https://affpapa.com/", "_blank");
            }}
          >
            <LazyLoad>
              <img src={affpapa} alt="logos" className="affpapa-logo" />
            </LazyLoad>
          </div>
          <div>
            <span
              onClick={() => {
                window.open("https://www.gamcare.org.uk/", "_blank");
              }}
              className="gamcare-link"
            >
              {" "}
              <LazyLoad>
                <img className="footerLogos" src={FooterLogos} alt="logos" />
              </LazyLoad>
            </span>
          </div>
          <div
            onClick={() => {
              window.open(
                "https://www.gamblingcontrol.org/licensees/egambling-licensees/",
                "_blank"
              );
            }}
          >
            <React.Suspense
              fallback={<div className="fallback">loading...</div>}
            >
              <LogoAlderney className="terms__logos__alderney-logo" />
            </React.Suspense>
          </div>
        </div>
      </div>
      {showModal && (
        <PublicModal
          showModal={showModal}
          closeModal={onCloseModal}
          content={
            <div
              className="footer-container__modal"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(html),
              }}
            />
          }
        />
      )}
    </div>
  );
};

export default injectIntl(Footer);
